import { render, staticRenderFns } from "./eg_dropdown.vue?vue&type=template&id=2fdadd62&scoped=true&"
import script from "./eg_dropdown.vue?vue&type=script&lang=js&"
export * from "./eg_dropdown.vue?vue&type=script&lang=js&"
import style0 from "./eg_dropdown.vue?vue&type=style&index=0&id=2fdadd62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdadd62",
  null
  
)

export default component.exports